// 时间or时区相关 utils

// 兼容方法：通过时间偏移量计算时区
export function getCompatibleTimeZone() {
  const now = new Date();
  const localOffset = now.getTimezoneOffset() * 60000; // 偏移量单位为毫秒
  const offsetHours = localOffset / (60 * 60 * 1000); // 将偏移量转换为小时
  const isOffsetNegative = offsetHours < 0;
  const absOffsetHours = Math.abs(offsetHours);
  const offsetString = `${isOffsetNegative ? '-' : '+'}${String(Math.floor(absOffsetHours)).padStart(2, '0')}:${String(Math.round((absOffsetHours - Math.floor(absOffsetHours)) * 60)).padStart(2, '0')}`;
  return `UTC${offsetString}`;
}

// 导出一个函数，用于获取时区
export function getTimeZone() {
  // 首先尝试使用 Intl.DateTimeFormat 的 resolvedOptions 方法获取时区
  if (Intl && typeof Intl.DateTimeFormat === 'function' && typeof Intl.DateTimeFormat().resolvedOptions === 'function') {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
  } else {
    // 如果不支持，使用兼容方法获取时区偏移量
    return getCompatibleTimeZone();
  }
}